export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "reviews__sizeWorn--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Size"])},
        "reviews__colorWorn--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Color"])},
        "reviews__runsSmall--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Runs Small"])},
        "reviews__trueToSize--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["True to Size"])},
        "reviews__runsLarge--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Runs Large"])},
        "profile__height--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Height"])},
        "profile__weight--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weight"])},
        "profile__pounds--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["lbs."])},
        "profile__bust--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bra Size"])},
        "profile__age--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Age"])},
        "profile__bodyType--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Body Type"])},
        "profile__bodyType--apple": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apple"])},
        "profile__bodyType--pear": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pear"])},
        "profile__bodyType--hourGlass": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hourglass"])},
        "profile__bodyType--invertedTriangle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inverted Triangle"])},
        "profile__bodyType--stringNarrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Straight "])},
        "profile__blankBodyShape--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["- -"])}
      }
    }
  })
}
